export const ADMIN_API_ENDPOINT = "https://college-website-qpqz.onrender.com/api/v1/admin";
export const NOTICE_API_ENDPOINT = "https://college-website-qpqz.onrender.com/api/v1/notice";
export const EVENT_API_ENDPOINT = "https://college-website-qpqz.onrender.com/api/v1/event";
export const NEWS_API_ENDPOINT = "https://college-website-qpqz.onrender.com/api/v1/news";
export const GALLERY_API_ENDPOINT = "https://college-website-qpqz.onrender.com/api/v1/gallery";
export const ANNOUNCEMENT_API_ENDPOINT = "https://college-website-qpqz.onrender.com/api/v1/announcement";

